import s from './CtaButton.module.scss';
import { usewpdataSelectors } from '../../../lib/wpdataState/selectors';
import Button from '../../Button/CTA/Button';

const CtaButton = ({ className = '' }) => {
  const { hero } = usewpdataSelectors();

  return (
    <section className={s.quantity}>
      <div className={s.ctaWrapper}>
        <Button text={hero?.ctaButtonText} className={`${s.ctaButton} ${className}`.trim()} isLink={true} />
      </div>
    </section>
  );
};

export default CtaButton;
